var selector = {
    searchIconButton: '[data-search-drawer]',
    resultContainer: '[data-search-result]',
    searchInput: '[data-searchbar__input]',
    searchForm: '[data-mg-search]',
    searchClose: '[data-search-close]',
    recentSearchClear: '[data-recent-clear]'
};
let formSearch = document.querySelectorAll(selector.searchForm);
let formDestination = '/search';
Array.from(formSearch).forEach(function(form) {
    formDestination = form.getAttribute('action');
    form.addEventListener("submit", function(event) {
        const form = event.target;
        const formFields = form.elements;
        const searchTerm = formFields.q.value;
        if (searchTerm.replace(/\s/g, '').length > 0) {
            __setRecentSearch(searchTerm);
        }
    });
});
let searchSelectors = document.querySelectorAll(selector.searchIconButton);
if (searchSelectors) {
    Array.from(searchSelectors).forEach(function(seachSelector) {
        seachSelector.addEventListener("click", (e) => {
            e.preventDefault();
            var searchDrawer = document.querySelector(".searchbar");
            if (searchDrawer.classList.contains('search-drawer-active')) {
                searchDrawer.classList.remove('search-drawer-active');
                document.querySelector('body').classList.remove('no-scroll')
                stopFocusRotation();
                previousFocusElement.focus();
                previousFocusElement = '';
            } else {
                searchDrawer.classList.add('search-drawer-active');
                document.querySelector('body').classList.add('no-scroll')
                let querySelectorForSearch = document.querySelector("[data-recent-search]");
                if (__getRecentSearch() && querySelectorForSearch) {
                    querySelectorForSearch.innerHTML = __getRecentSearch();
                    __clearRecentSearch();
                    querySelectorForSearch.classList.remove('hidden')
                }
                previousFocusElement = seachSelector;
                focusElementsRotation(searchDrawer);
                setTimeout(() => {
                    document.querySelector(selector.searchInput).setAttribute('tabindex', '0');
                    document.querySelector(selector.searchInput).focus()
                }, 100);
               
            }
            __searchResult(document.querySelector(selector.searchInput).value = '');
        });
        seachSelector.addEventListener("keydown", (e) => {
            document.querySelector('body').classList.add('tab-focus')
        })
    })
}
let searchCloses = document.querySelectorAll(selector.searchClose);
if (searchCloses) {
    Array.from(searchCloses).forEach(function(seachClose) {
        seachClose.addEventListener("click", (e) => {
            e.preventDefault();
            var searchDrawer = document.querySelector(".searchbar");
            if (searchDrawer.classList.contains('search-drawer-active')) {
                stopFocusRotation();
                if (previousFocusElement) {
                    previousFocusElement.focus();
                }
                previousFocusElement = '';
                searchDrawer.classList.remove('search-drawer-active');
                document.querySelector('body').classList.remove('no-scroll')
            }
        });
    })
}
// search input 
var searchTyping;
document.querySelector(selector.searchInput).addEventListener("keyup", (event) => {
    event.preventDefault();
    clearTimeout(searchTyping);
    searchTyping = setTimeout(function() {
        let searchTerm = document.querySelector(selector.searchInput).value;
        if (searchTerm.replace(/\s/g, '').length > 0) {
            __setRecentSearch(searchTerm);
        }
        __searchResult(searchTerm);
    }, 1000)

});

// searchResult funtion
var __searchResult = function(searchTerm) {
        let resultContainer = document.querySelector(selector.resultContainer);
        let querySelectorForSearch = document.querySelector("[data-recent-search]");
        if (__getRecentSearch() && querySelectorForSearch) {
            querySelectorForSearch.innerHTML = __getRecentSearch();
            __clearRecentSearch();
            // querySelectorForSearch.classList.remove('hidden')
        }
        if (searchTerm.replace(/\s/g, '').length > 0) {
            resultContainer.innerHTML = preLoadLoadGif;
            const predictiveSearchUrl =
    formDestination +
    "/suggest?section_id=predictive-search" +
    "&q=" + encodeURIComponent(searchTerm) +
    "&resources[limit]=10" +
    "&resources[options][unavailable_products]=show";

fetch(predictiveSearchUrl)
                .then((response) => {
                    return response.text();
                })
                .then((responseText) => {
                    let resultsMarkup = new DOMParser().parseFromString(responseText, 'text/html');
                    if(resultsMarkup.querySelector('#shopify-section-predictive-search')){
                        resultContainer.innerHTML = resultsMarkup.querySelector('#shopify-section-predictive-search').innerHTML;
                        __prioritizeSearchProducts(resultContainer, searchTerm);
                        __setupSearchFilters(resultContainer, searchTerm);
                        if (__getRecentSearch() && querySelectorForSearch) {
                            querySelectorForSearch.innerHTML = __getRecentSearch();
                            querySelectorForSearch.classList.add('hidden')
                        }
                        if (animationStatus) {
                            if (AOS) {
                                AOS.refreshHard()
                            }
                        }   
                    }else{
                        resultContainer.innerHTML='Invalid parameter error.';
                        querySelectorForSearch.classList.add('hidden')
                    }
                })
        } else {
            resultContainer.innerHTML = '';
            if (__getRecentSearch() && querySelectorForSearch) {
                querySelectorForSearch.innerHTML = __getRecentSearch();
                __clearRecentSearch();
                querySelectorForSearch.classList.remove('hidden')
            }
        }
    }
    var __prioritizeSearchProducts = function(resultContainer, searchTerm) {
    let productContainer = resultContainer.querySelector('[data-search-products]');
    let products = Array.from(resultContainer.querySelectorAll('[data-search-product]'));
    let normalizedTerm = searchTerm
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ');

    if (!productContainer || !products.length || !normalizedTerm) {
        return;
    }

    let searchWords = normalizedTerm.split(' ');

    products
        .map(function(product, originalIndex) {
            let title = (product.getAttribute('data-product-title') || '')
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9]+/g, ' ')
                .replace(/\s+/g, ' ');

            let score = 4;

            if (title === normalizedTerm) {
                score = 0;
            } else if (title.indexOf(normalizedTerm) === 0) {
                score = 1;
            } else if (title.indexOf(normalizedTerm) !== -1) {
                score = 2;
            } else if (
                searchWords.every(function(word) {
                    return title.indexOf(word) !== -1;
                })
            ) {
                score = 3;
            }

            return {
                element: product,
                score: score,
                originalIndex: originalIndex
            };
        })
        .sort(function(firstProduct, secondProduct) {
            return (
                firstProduct.score - secondProduct.score ||
                firstProduct.originalIndex - secondProduct.originalIndex
            );
        })
        .forEach(function(product) {
            productContainer.appendChild(product.element);
        });
};

    var __fetchStoreSearchProducts = function(searchTerm) {
    let matchedProducts = [];
    let page = 1;
    let shopRoot =
        window.Shopify && Shopify.routes && Shopify.routes.root
            ? Shopify.routes.root
            : '/';

    let fetchPage = function() {
        let storeSearchUrl =
            shopRoot +
            'search?section_id=predictive-search-store' +
            '&type=product' +
            '&options%5Bprefix%5D=last' +
            '&q=' + encodeURIComponent(searchTerm) +
            '&page=' + page;

        return fetch(storeSearchUrl)
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Unable to load in-store products.');
                }

                return response.text();
            })
            .then(function(responseText) {
                let storeResults = new DOMParser().parseFromString(
                    responseText,
                    'text/html'
                );
                let storePage = storeResults.querySelector(
                    '[data-store-search-page]'
                );

                if (!storePage) {
                    return matchedProducts;
                }

                Array.from(
                    storePage.querySelectorAll('[data-store-search-product]')
                ).some(function(product) {
                    matchedProducts.push(product);

                    return matchedProducts.length >= 10;
                });

                let nextPage = parseInt(
                    storePage.getAttribute('data-next-page'),
                    10
                );

                if (matchedProducts.length < 10 && nextPage) {
                    page = nextPage;
                    return fetchPage();
                }

                return matchedProducts;
            });
    };

    if (!searchTerm.trim()) {
        return Promise.resolve([]);
    }

    return fetchPage();
};

    var __setupSearchFilters = function(resultContainer, searchTerm) {
    let filterButtons = resultContainer.querySelectorAll('[data-search-filter]');
    let productContainer = resultContainer.querySelector('[data-search-products]');
    let emptyMessage = resultContainer.querySelector('[data-search-filter-empty]');
    let storeAction = resultContainer.querySelector('.predictive-search__store-action');
    let allResultsLink = resultContainer.querySelector('.searchbar__result-all');
    let originalEmptyMessage = emptyMessage ? emptyMessage.textContent : '';
    let selectedFilter = 'all';
    let storeSearchState = 'idle';

    if (!filterButtons.length || !productContainer) {
        return;
    }

    let applyFilter = function(filterValue) {
        selectedFilter = filterValue;

        if (filterValue === 'store' && storeSearchState === 'idle') {
            storeSearchState = 'loading';
            productContainer.setAttribute('aria-busy', 'true');

            Array.from(
                resultContainer.querySelectorAll('[data-search-product]')
            ).forEach(function(product) {
                product.hidden = true;
            });

            if (emptyMessage) {
                emptyMessage.textContent = 'Searching in-store products...';
                emptyMessage.hidden = false;
            }

            if (storeAction) {
                storeAction.hidden = true;
            }

            if (allResultsLink) {
                allResultsLink.hidden = true;
            }

            __fetchStoreSearchProducts(searchTerm)
                .then(function(storeProducts) {
                    storeProducts.forEach(function(product) {
                        productContainer.appendChild(product);
                    });
                    storeSearchState = 'loaded';
                })
                .catch(function() {
                    storeSearchState = 'failed';
                })
                .then(function() {
                    productContainer.removeAttribute('aria-busy');

                    if (selectedFilter === 'store') {
                        applyFilter('store');
                    }
                });

            return;
        }

        let visibleCount = 0;
        let products = Array.from(
            resultContainer.querySelectorAll('[data-search-product]')
        );

        products.forEach(function(product) {
            let productChannel = product.getAttribute('data-search-channel');
            let isDedicatedStoreResult = product.hasAttribute(
                'data-store-search-product'
            );
            let shouldShow =
                (filterValue === 'all' && !isDedicatedStoreResult) ||
                (filterValue === 'online' &&
                    !isDedicatedStoreResult &&
                    productChannel === 'online') ||
                (filterValue === 'store' && isDedicatedStoreResult);

            product.hidden = !shouldShow;

            if (shouldShow) {
                visibleCount += 1;
            }
        });

        if (emptyMessage) {
            emptyMessage.textContent = originalEmptyMessage;
            emptyMessage.hidden = visibleCount > 0;
        }

        if (storeAction) {
            storeAction.hidden =
                filterValue !== 'store' ||
                visibleCount === 0;
        }

        if (allResultsLink) {
            allResultsLink.hidden =
                visibleCount === 0 ||
                filterValue === 'store';
        }
    };

    Array.from(filterButtons).forEach(function(filterButton) {
        filterButton.addEventListener('click', function() {
            let filterValue = filterButton.getAttribute('data-search-filter');

            Array.from(filterButtons).forEach(function(button) {
                let isSelected = button === filterButton;

                button.classList.toggle('is-active', isSelected);
                button.setAttribute('aria-pressed', isSelected.toString());
            });

            applyFilter(filterValue);
        });
    });

    applyFilter('all');
};

    // set recent search item in the local storage
var __setRecentSearch = function(sarchItem) {
    var localStorageValue = JSON.parse(localStorage.getItem("recent-search")) || [];
    if (localStorageValue && localStorageValue.length > 0) {
        if (localStorageValue.indexOf(sarchItem) < 0) {
            if (localStorageValue.length >= 20) {
                localStorageValue.shift();
            }
            localStorageValue.push(sarchItem)
            localStorage.setItem("recent-search", JSON.stringify(localStorageValue));
        }
    } else {
        localStorageValue.push(sarchItem);
        localStorage.setItem("recent-search", JSON.stringify(localStorageValue));
    }
}
var __clearRecentSearch = function() {
        let clearButton = document.querySelector(selector.recentSearchClear);
        let querySelectorForSearch = document.querySelector("[data-recent-search]");
        if (clearButton) {
            clearButton.addEventListener('click', function(event) {
                event.preventDefault();
                localStorage.removeItem("recent-search");
                querySelectorForSearch.classList.add('hidden');
            })
        }
    }
    // get recent serach name;
var __getRecentSearch = function() {
    let localStorageValue = JSON.parse(localStorage.getItem("recent-search"));
    let recentHtml = '';
    if (localStorageValue && localStorageValue.length > 0) {
        recentHtml = '<h6 class="searchbar__recent-heading text-small">Recent Search</h6><ul class="list-unstyled recent__list">'
        localStorageValue.reverse();
        Array.from(localStorageValue).forEach(function(recent, index) {
            if (recent != '') {
                recentHtml += '<li class="recent__list-item"><a class="recent__list-link unstyled-link" href="/search?q=' + recent + '">' + recent + '</a></li>'
            }
        })
        recentHtml += '<li class="recent__list-item clear-recent" data-recent-clear><a class="recent__list-link unstyled-link" href="#">Clear</a></li></ul>';
    }
    return recentHtml;
}
